import { useHostServices } from '../HostServices'
import { Flags, defaultValues } from '../utils/feature-flags'

const useFeatureFlags = (flagName: Flags): any => {
  const services = useHostServices()

  const fallBack = defaultValues[flagName]
  return services && services.featureFlags
    ? services.featureFlags.variation(flagName, fallBack)
    : /* istanbul ignore next */ fallBack
}

export { useFeatureFlags }
